export const UPDATE_DEVICE_SN_LIST_CSV_API = '/subscriber/serialnumbers/list?';
export const FETCH_DEVICE_SN_SERIAL_NUMBER = '/subscriber/serialnumbers/:id';
export const FETCH_DEVICE_SN_UUID = '/device/retail/:serialnumber';
export const FETCH_DEVICE_SN_PACKET_DETAILS = 'packet/:uuid?';
